import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { ContainerService } from '../../service/container.service';

import { AbstractListComponent } from '../../common/abstract-list-component';
import { Container } from '../../model/container';
import { takeUntil, take } from 'rxjs/operators';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { ListableService } from 'src/app/service/listable.service';
import { LISTABLE_SECTOR_KEY } from 'src/app/constants/constants';
import { Table } from 'primeng/table/table';
import { KeycloakService } from 'keycloak-angular-support-v8-9';

@Component({
    selector: 'app-container-list',
    templateUrl: './container-list.component.html',
})
export class ContainerListComponent extends AbstractListComponent<Container> implements OnInit {
    element: Container;
    listableSectorItems: SelectItem[];

    roles: any;
    primaryRole: any;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected containerService: ContainerService,
        private listableService: ListableService,
        private confirmationService: ConfirmationService,
        protected keycloakService: KeycloakService
    ) {
        super(router, containerService, 'gare');
    }

    ngOnInit() {
        this.roles = this.keycloakService.getUserRoles();
        this.setPrimaryRole();
        // super.ngOnInit();
        this.loading = true;
        this.element = new Container();
        this.getSectorItems();
    }

    setPrimaryRole() {
        if (this.roles) {
            if (this.roles.includes('admin')) {
                this.primaryRole = 'Admin';
                return;
            }
            if (this.roles.includes('user')) {
                this.primaryRole = 'Utente';
                return;
            }
            if (this.roles.includes('manager')) {
                this.primaryRole = 'Manager';
                return;
            }
        }
    }

    clone(container) {
        this.router.navigate(['/' + this.path + '/clone/' + container.codiceGara]);
    }

    getSectorItems() {
        this.listableService
            .listValuesAsItems(LISTABLE_SECTOR_KEY)
            .subscribe((settoreItems) => (this.listableSectorItems = settoreItems));
    }

    newElement(): Container {
        return super.newElement();
    }

    delete(element: Container) {
        this.service
            .delete(element.codiceGara)
            .pipe(takeUntil(this.destroy$))
            .subscribe((del) => this.loaddata(true));
    }

    public new() {
        this.router.navigate(['/' + this.path + '/new']);
    }

    public reload(datatable: Table) {
        if (!this.service.search.obj.archived) this.service.search.obj.archived = null;
        if (!this.service.search.obj.closed) this.service.search.obj.closed = null;
        super.reload(datatable);
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                deadline: this.service.search.from?.deadline?.split('T')[0],
                prorogation: this.service.search.from?.prorogation?.split('T')[0],
            },
            to: {
                ...this.service.search.to,
                deadline: this.service.search.to?.deadline?.split('T')[0],
                prorogation: this.service.search.to?.prorogation?.split('T')[0],
            },
        };
    }

    public preLoaddata() {
        this.service.search = {
            ...this.service.search,
            from: {
                ...this.service.search.from,
                deadline: this.normalizeDateFilter(this.service.search?.from?.deadline),
                prorogation: this.normalizeDateFilter(this.service.search?.from?.prorogation),
            },
            to: {
                ...this.service.search.to,
                deadline: this.normalizeDateFilter(this.service.search?.to?.deadline, true),
                prorogation: this.normalizeDateFilter(this.service.search?.to?.prorogation, true),
            },
        };
    }

    private normalizeDateFilter(dateValue: any, endOfDay = false): string {
        if (!dateValue) {
            return null;
        }

        if (dateValue instanceof Date) {
            const year = dateValue.getFullYear();
            const month = `${dateValue.getMonth() + 1}`.padStart(2, '0');
            const day = `${dateValue.getDate()}`.padStart(2, '0');
            return `${year}-${month}-${day}${endOfDay ? 'T23:59:59' : 'T00:00:00'}`;
        }

        const rawDateValue = `${dateValue}`;
        const datePart = rawDateValue.split('T')[0].split(',')[0].trim();

        if (!datePart) {
            return null;
        }

        const separator = datePart.includes('/') ? '/' : '-';
        const dateParts = datePart.split(separator);

        if (dateParts.length !== 3) {
            return null;
        }

        const isYearFirst = dateParts[0].length === 4;
        const year = isYearFirst ? dateParts[0] : dateParts[2];
        const month = isYearFirst ? dateParts[1] : dateParts[1];
        const day = isYearFirst ? dateParts[2] : dateParts[0];

        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}${
            endOfDay ? 'T23:59:59' : 'T00:00:00'
        }`;
    }

    public formatDateChip(dateValue: any): string {
        if (!dateValue) {
            return '';
        }

        const datePart = `${dateValue}`.split('T')[0].split(',')[0].trim();
        if (!datePart) {
            return '';
        }

        const separator = datePart.includes('/') ? '/' : '-';
        const dateParts = datePart.split(separator);

        if (dateParts.length !== 3) {
            return datePart;
        }

        return dateParts[0].length === 4
            ? `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
            : `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
    }

    getId() {
        return this.element.codiceGara;
    }

    createInstance(): Container {
        return new Container();
    }

    addArticles(uuid: string) {
        this.router.navigate([`/${this.path}/${uuid}/aggiungi-articoli`]);
    }

    addCatalogues(uuid: string) {
        this.router.navigate([`/${this.path}/${uuid}/aggiungi-cataloghi`]);
    }

    close(element: Container) {
        this.confirmationService.confirm({
            accept: () => {
                this.containerService
                    .closeContainer(element.codiceGara)
                    .pipe(take(1))
                    .subscribe(
                        (closedContainer) =>
                            (this.model = this.model.map((gara) =>
                                gara.codiceGara === closedContainer.codiceGara
                                    ? closedContainer
                                    : gara
                            ))
                    );
            },
        });
    }

    open(element: Container): void {
        this.confirmationService.confirm({
            accept: () => {
                this.containerService
                    .openContainer(element.codiceGara)
                    .pipe(take(1))
                    .subscribe(
                        (openedContainer) =>
                            (this.model = this.model.map((gara) =>
                                gara.codiceGara === openedContainer.codiceGara
                                    ? openedContainer
                                    : gara
                            ))
                    );
            },
        });
    }

    archive(element: Container) {
        this.confirmationService.confirm({
            accept: () => {
                this.containerService
                    .archiveContainer(element.codiceGara)
                    .pipe(take(1))
                    .subscribe(
                        (archivedContainer) =>
                            (this.model = this.model.map((gara) =>
                                gara.codiceGara === archivedContainer.codiceGara
                                    ? archivedContainer
                                    : gara
                            ))
                    );
            },
        });
    }

    unarchive(element: Container) {
        this.confirmationService.confirm({
            accept: () => {
                this.containerService
                    .unarchiveContainer(element.codiceGara)
                    .pipe(take(1))
                    .subscribe(
                        (unarchivedContainer) =>
                            (this.model = this.model.map((gara) =>
                                gara.codiceGara === unarchivedContainer.codiceGara
                                    ? unarchivedContainer
                                    : gara
                            ))
                    );
            },
        });
    }
}
